import { render, staticRenderFns } from "./SubjectPieChart.vue?vue&type=template&id=2a48f784&scoped=true"
import script from "./SubjectPieChart.vue?vue&type=script&lang=js"
export * from "./SubjectPieChart.vue?vue&type=script&lang=js"
import style0 from "./SubjectPieChart.vue?vue&type=style&index=0&id=2a48f784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a48f784",
  null
  
)

export default component.exports